import { Chip } from '@mui/material';
import type { UserActionHttpMethod } from '../types';

const COLORS: Record<UserActionHttpMethod, 'success' | 'warning' | 'error'> = {
  POST: 'success',
  PATCH: 'warning',
  DELETE: 'error',
};

interface Props {
  method: UserActionHttpMethod;
}

export function MethodBadge({ method }: Props) {
  return (
    <Chip
      label={method}
      size="small"
      color={COLORS[method]}
      variant="outlined"
      sx={{ fontFamily: 'monospace', fontWeight: 700, minWidth: 64 }}
    />
  );
}
